import { Component, OnInit } from '@angular/core';
import { apisDataCacheKeys, TRENDING, RECOMMENDED, ILSHORTS, TRENDING_VIDEOS_THIS_WEEK, RECOMMENDED_VIDEOS, INFINITY_SHORTS, PUZZLES } from 'projects/selflearnv2-ui/src/app/constants/app.constants';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-self-learn-videos',
  templateUrl: './self-learn-videos.component.html',
  styleUrls: ['./self-learn-videos.component.css']
})
export class SelfLearnVideosComponent implements OnInit {
  filterCMSData:any;
  cardList: any = [];
  title:string='';
  constructor(public selfLearnService:SelfLearnService, public router:Router) { }

  ngOnInit(): void {
   this.setVideoTypeDisplayName();
   this.getVideosList();
  }

  getVideosList() {
    const playListId = localStorage.getItem('selfLearnSelectedPlayList');
    const params = {
      examId: this.selfLearnService.getCmsExamID(),
      subTenantId: this.selfLearnService.getSubtenantId(),
      playlistTypeId: playListId,
    }
    this.selfLearnService.getVideosByPlayListId(params).subscribe((resp:any) => {
      let videos:any;
      this.cardList = [];
      videos = resp.data
      videos.map((item:any) => {
        item.videos.map((video:any) => {
          this.cardList.push(video);
        })
        
      })
      //this.cardList = resp.data[0].videos;
    })
  }

  navigatetoVideoPlayback(videoData:any){
    localStorage.setItem('selfLearnSelectedVideoId', videoData.videoId);
    localStorage.setItem("selfLearnPreviousPage", 'viewall');
    const videoType = localStorage.getItem("selfLearnSelectedVideoType");
    const navigationPath = (videoType == ILSHORTS) ? 'selfLearn-V2/shorts' : 'selfLearn-V2/videoplayback'
    this.router.navigateByUrl(navigationPath);
  }

  navigateToSelfLearnHomePage(){
    this.router.navigateByUrl('selfLearn-V2');
  }

  setVideoTypeDisplayName(){
    const videoType = localStorage.getItem("selfLearnSelectedVideoType");
    let title;
    switch (videoType) {
      case TRENDING:
        title = TRENDING_VIDEOS_THIS_WEEK;
        break;
      case RECOMMENDED:
        title = RECOMMENDED_VIDEOS
        break;
      case ILSHORTS:
        title = INFINITY_SHORTS
        break;
      case PUZZLES:
        title = PUZZLES
        break;
    
      default:
        break;
    }
    this.title = title;
  }

}
